export default __webpack_public_path__ + "images/plus_30b830.svg";